import React from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Join from './components/Join/Join';
import Chat from './components/Chat';
const App = () => (
    <Router>
        <Route path="/" exact component={Join} />
        <Route path="/chat" exact component={Chat} />
        <Redirect path="/" component={Join} />
    </Router>
);

export default App;
